import React, { useState, useEffect } from 'react';
import prodImporter from '@boschebike/ebds-js/dist-esm/helpers/web-generic/feedback.import.prod.js';
/**
 * @typedef {import('./WebGenericFeedbackModal.d.ts').WebGenericFeedbackModalProps} WebGenericFeedbackModalProps
 */

/**
 * @param {WebGenericFeedbackModalProps} props
 */
const WebGenericFeedbackModal = ({
  customImporter = prodImporter,
  product,
  productId,
  source,
  team,
  userType,
  onDismiss,
  onToast
}) => {
  const [modalNode, setModalNode] = useState(null);
  useEffect(() => {
    customImporter();
  }, []);
  useEffect(() => {
    if (!modalNode) {
      return () => {};
    }
    const listenerToast = event => {
      onToast(event.detail);
    };
    const listenerDismiss = () => {
      onDismiss();
    };
    modalNode.addEventListener('ebweb-feedback-modal-toast', listenerToast);
    modalNode.addEventListener('ebweb-feedback-modal-dismiss', listenerDismiss);
    return () => {
      modalNode.removeEventListener('ebweb-feedback-modal-toast', listenerToast);
      modalNode.removeEventListener('ebweb-feedback-modal-dismiss', listenerDismiss);
    };
  }, [modalNode, onDismiss, onToast]);
  return /*#__PURE__*/React.createElement("ebweb-feedback-modal", {
    // Human-readable name
    product: product
    // eBike readable name
    ,
    productId: productId
    // eBike readable team
    ,
    team: team
    // User type (e.g. B2B - organisation, internal = BOSCH, RIDER - flow user)
    ,
    userType: userType
    // can be anything, something for you to understand where it came from
    ,
    source: source,
    ref: setModalNode
  });
};
export default WebGenericFeedbackModal;